var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtenn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Extenn",
    transform: "translate(-1142.436 -549.14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6781",
    "data-name": "Path 6781",
    d: "M1153.436,549.14h-7a4,4,0,0,0-4,4v7a4,4,0,0,0,4,4h7a4.005,4.005,0,0,0,4-4v-7A4,4,0,0,0,1153.436,549.14Zm.2,9.841v.993a1.4,1.4,0,0,1-1.351,1.4v.014h-1.4v-.009h-.466l-.006-.467a.9.9,0,0,0-.823-.9l-.138-.033a.383.383,0,0,1-.12.033l-.123.04a.892.892,0,0,0-.64.859v.473h-.472v.009h-1.4v-.009h-.047a1.4,1.4,0,0,1-1.4-1.4h0V558.1h.472a.922.922,0,1,0,0-1.843h-.472v-1.872a1.4,1.4,0,0,1,1.4-1.4h.994a1.857,1.857,0,0,1,3.6,0h.993a1.4,1.4,0,0,1,1.4,1.4v.994a1.856,1.856,0,0,1,0,3.6Z",
    fill: "#28a745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6782",
    "data-name": "Path 6782",
    d: "M1152.239,553.936h-5.585a.453.453,0,0,0-.453.453v.986a1.866,1.866,0,0,1,0,3.613v.986a.453.453,0,0,0,.453.454h1.035a1.836,1.836,0,0,1,1.265-1.295,1.021,1.021,0,0,1,.186-.056.94.94,0,0,1,.585-.012,1.836,1.836,0,0,1,1.572,1.363h.942a.454.454,0,0,0,.454-.454v-5.585A.453.453,0,0,0,1152.239,553.936Z",
    fill: "#28a745"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtenn);
export default __webpack_public_path__ + "static/media/Extenn.a7e64fc782b2dd76975f998d473501f6.svg";
export { ForwardRef as ReactComponent };